// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Barlow+Condensed:wght@600;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background: #0f172a;
  color: #e2e8f0;
  overflow-x: hidden;
}

.App {
  min-height: 100vh;
}

/* Navbar */
.navbar {
  background: #1e293b;
  padding: 1rem 2rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 2px solid #334155;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.3);
}

.nav-brand h1 {
  font-size: 1.5rem;
  color: #f59e0b;
  font-weight: 700;
}

.nav-links {
  display: flex;
  gap: 2rem;
}

.nav-links a {
  color: #cbd5e1;
  text-decoration: none;
  font-weight: 500;
  padding: 0.5rem 1rem;
  border-radius: 6px;
  transition: all 0.2s;
}

.nav-links a:hover {
  background: #334155;
  color: #f59e0b;
}

.nav-stats {
  display: flex;
  gap: 2rem;
  font-size: 0.875rem;
  color: #94a3b8;
}

.nav-stats span {
  padding: 0.5rem 1rem;
  background: #334155;
  border-radius: 6px;
}

.nav-user {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  margin-left: 1rem;
}

.nav-username {
  color: #cbd5e1;
  font-size: 0.875rem;
  font-weight: 500;
}

.nav-admin-badge {
  background: rgba(245, 158, 11, 0.15);
  color: #f59e0b;
  border: 1px solid rgba(245, 158, 11, 0.3);
  border-radius: 4px;
  padding: 0.15rem 0.5rem;
  font-size: 0.7rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.nav-logout-btn {
  padding: 0.35rem 0.875rem;
  background: transparent;
  color: #64748b;
  border: 1px solid #475569;
  border-radius: 6px;
  font-size: 0.8rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
}

.nav-logout-btn:hover {
  background: #334155;
  color: #f1f5f9;
  border-color: #64748b;
}

/* Hamburger — hidden on desktop */
.nav-hamburger {
  display: none;
  background: none;
  border: 1px solid #334155;
  border-radius: 4px;
  padding: 0.4rem;
  cursor: pointer;
  flex-direction: column;
  gap: 4px;
}
.nav-hamburger span {
  display: block;
  width: 20px;
  height: 2px;
  background: #cbd5e1;
  border-radius: 1px;
}

/* Container */
.container {
  max-width: 1400px;
  margin: 0 auto;
  padding: 2rem;
}

/* Loading */
.loading {
  text-align: center;
  padding: 4rem;
  font-size: 1.25rem;
  color: #64748b;
}

/* Buttons */
.btn {
  padding: 0.75rem 1.5rem;
  border: none;
  border-radius: 6px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
  text-decoration: none;
  display: inline-block;
}

.btn-primary {
  background: #3b82f6;
  color: white;
}

.btn-primary:hover {
  background: #2563eb;
}

.btn-primary:disabled {
  background: #475569;
  cursor: not-allowed;
}

.btn-success {
  background: #10b981;
  color: white;
}

.btn-success:hover {
  background: #059669;
}

.btn-secondary {
  background: #64748b;
  color: white;
}

.btn-secondary:hover {
  background: #475569;
}

.btn-small {
  padding: 0.25rem 0.75rem;
  font-size: 0.875rem;
  border-radius: 4px;
}

.btn-info {
  background: #0ea5e9;
  color: white;
}

h2 {
  color: #f1f5f9;
  margin-bottom: 1.5rem;
  font-size: 1.875rem;
}

h3 {
  color: #cbd5e1;
  margin-bottom: 1rem;
}

@media (max-width: 768px) {
  .navbar { flex-wrap: wrap; gap: 0.5rem; padding: 0.75rem 1rem; }
  .nav-brand h1 { font-size: 1.1rem; }
  .nav-links { gap: 0.75rem; flex-wrap: wrap; }
  .nav-links a { padding: 0.4rem 0.6rem; font-size: 0.85rem; }
  .nav-stats { display: none; }
  .nav-user { margin-left: 0; }
  .nav-username { display: none; }
  .container { padding: 1rem; }
  .fights-table-container { overflow-x: auto; -webkit-overflow-scrolling: touch; }
  .fights-table { min-width: 0; }
}

@media (max-width: 600px) {
  .navbar {
    padding: 0.5rem 0.75rem;
    flex-wrap: nowrap;
  }
  .nav-brand h1 { font-size: 1rem; }

  /* Show hamburger, hide links by default */
  .nav-hamburger { display: flex; }
  .nav-links {
    display: none;
    width: 100%;
    flex-direction: column;
    gap: 0;
    order: 10;
    background: #0f172a;
    border-top: 1px solid #334155;
    margin-top: 0.5rem;
  }
  .nav-links.nav-open { display: flex; }
  .nav-links a {
    padding: 0.6rem 0.75rem;
    font-size: 0.85rem;
    border-bottom: 1px solid #1e293b;
  }

  /* Hide user section on mobile (sign out via settings) */
  .nav-user { display: none; }

  .container { padding: 0.6rem; }
}

`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAEA;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE;;cAEY;EACZ,mCAAmC;EACnC,kCAAkC;EAClC,mBAAmB;EACnB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA,WAAW;AACX;EACE,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,gCAAgC;EAChC,6CAA6C;AAC/C;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,cAAc;EACd,yCAAyC;EACzC,kBAAkB;EAClB,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,uBAAuB;EACvB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA,kCAAkC;AAClC;EACE,aAAa;EACb,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,cAAc;EACd,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA,cAAc;AACd;EACE,iBAAiB;EACjB,cAAc;EACd,aAAa;AACf;;AAEA,YAAY;AACZ;EACE,kBAAkB;EAClB,aAAa;EACb,kBAAkB;EAClB,cAAc;AAChB;;AAEA,YAAY;AACZ;EACE,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,UAAU,eAAe,EAAE,WAAW,EAAE,qBAAqB,EAAE;EAC/D,gBAAgB,iBAAiB,EAAE;EACnC,aAAa,YAAY,EAAE,eAAe,EAAE;EAC5C,eAAe,sBAAsB,EAAE,kBAAkB,EAAE;EAC3D,aAAa,aAAa,EAAE;EAC5B,YAAY,cAAc,EAAE;EAC5B,gBAAgB,aAAa,EAAE;EAC/B,aAAa,aAAa,EAAE;EAC5B,0BAA0B,gBAAgB,EAAE,iCAAiC,EAAE;EAC/E,gBAAgB,YAAY,EAAE;AAChC;;AAEA;EACE;IACE,uBAAuB;IACvB,iBAAiB;EACnB;EACA,gBAAgB,eAAe,EAAE;;EAEjC,0CAA0C;EAC1C,iBAAiB,aAAa,EAAE;EAChC;IACE,aAAa;IACb,WAAW;IACX,sBAAsB;IACtB,MAAM;IACN,SAAS;IACT,mBAAmB;IACnB,6BAA6B;IAC7B,kBAAkB;EACpB;EACA,sBAAsB,aAAa,EAAE;EACrC;IACE,uBAAuB;IACvB,kBAAkB;IAClB,gCAAgC;EAClC;;EAEA,wDAAwD;EACxD,YAAY,aAAa,EAAE;;EAE3B,aAAa,eAAe,EAAE;AAChC","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Barlow+Condensed:wght@600;700&display=swap');\n\n* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\nbody {\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\n    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\n    sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  background: #0f172a;\n  color: #e2e8f0;\n  overflow-x: hidden;\n}\n\n.App {\n  min-height: 100vh;\n}\n\n/* Navbar */\n.navbar {\n  background: #1e293b;\n  padding: 1rem 2rem;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  border-bottom: 2px solid #334155;\n  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.3);\n}\n\n.nav-brand h1 {\n  font-size: 1.5rem;\n  color: #f59e0b;\n  font-weight: 700;\n}\n\n.nav-links {\n  display: flex;\n  gap: 2rem;\n}\n\n.nav-links a {\n  color: #cbd5e1;\n  text-decoration: none;\n  font-weight: 500;\n  padding: 0.5rem 1rem;\n  border-radius: 6px;\n  transition: all 0.2s;\n}\n\n.nav-links a:hover {\n  background: #334155;\n  color: #f59e0b;\n}\n\n.nav-stats {\n  display: flex;\n  gap: 2rem;\n  font-size: 0.875rem;\n  color: #94a3b8;\n}\n\n.nav-stats span {\n  padding: 0.5rem 1rem;\n  background: #334155;\n  border-radius: 6px;\n}\n\n.nav-user {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  margin-left: 1rem;\n}\n\n.nav-username {\n  color: #cbd5e1;\n  font-size: 0.875rem;\n  font-weight: 500;\n}\n\n.nav-admin-badge {\n  background: rgba(245, 158, 11, 0.15);\n  color: #f59e0b;\n  border: 1px solid rgba(245, 158, 11, 0.3);\n  border-radius: 4px;\n  padding: 0.15rem 0.5rem;\n  font-size: 0.7rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n}\n\n.nav-logout-btn {\n  padding: 0.35rem 0.875rem;\n  background: transparent;\n  color: #64748b;\n  border: 1px solid #475569;\n  border-radius: 6px;\n  font-size: 0.8rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.nav-logout-btn:hover {\n  background: #334155;\n  color: #f1f5f9;\n  border-color: #64748b;\n}\n\n/* Hamburger — hidden on desktop */\n.nav-hamburger {\n  display: none;\n  background: none;\n  border: 1px solid #334155;\n  border-radius: 4px;\n  padding: 0.4rem;\n  cursor: pointer;\n  flex-direction: column;\n  gap: 4px;\n}\n.nav-hamburger span {\n  display: block;\n  width: 20px;\n  height: 2px;\n  background: #cbd5e1;\n  border-radius: 1px;\n}\n\n/* Container */\n.container {\n  max-width: 1400px;\n  margin: 0 auto;\n  padding: 2rem;\n}\n\n/* Loading */\n.loading {\n  text-align: center;\n  padding: 4rem;\n  font-size: 1.25rem;\n  color: #64748b;\n}\n\n/* Buttons */\n.btn {\n  padding: 0.75rem 1.5rem;\n  border: none;\n  border-radius: 6px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s;\n  text-decoration: none;\n  display: inline-block;\n}\n\n.btn-primary {\n  background: #3b82f6;\n  color: white;\n}\n\n.btn-primary:hover {\n  background: #2563eb;\n}\n\n.btn-primary:disabled {\n  background: #475569;\n  cursor: not-allowed;\n}\n\n.btn-success {\n  background: #10b981;\n  color: white;\n}\n\n.btn-success:hover {\n  background: #059669;\n}\n\n.btn-secondary {\n  background: #64748b;\n  color: white;\n}\n\n.btn-secondary:hover {\n  background: #475569;\n}\n\n.btn-small {\n  padding: 0.25rem 0.75rem;\n  font-size: 0.875rem;\n  border-radius: 4px;\n}\n\n.btn-info {\n  background: #0ea5e9;\n  color: white;\n}\n\nh2 {\n  color: #f1f5f9;\n  margin-bottom: 1.5rem;\n  font-size: 1.875rem;\n}\n\nh3 {\n  color: #cbd5e1;\n  margin-bottom: 1rem;\n}\n\n@media (max-width: 768px) {\n  .navbar { flex-wrap: wrap; gap: 0.5rem; padding: 0.75rem 1rem; }\n  .nav-brand h1 { font-size: 1.1rem; }\n  .nav-links { gap: 0.75rem; flex-wrap: wrap; }\n  .nav-links a { padding: 0.4rem 0.6rem; font-size: 0.85rem; }\n  .nav-stats { display: none; }\n  .nav-user { margin-left: 0; }\n  .nav-username { display: none; }\n  .container { padding: 1rem; }\n  .fights-table-container { overflow-x: auto; -webkit-overflow-scrolling: touch; }\n  .fights-table { min-width: 0; }\n}\n\n@media (max-width: 600px) {\n  .navbar {\n    padding: 0.5rem 0.75rem;\n    flex-wrap: nowrap;\n  }\n  .nav-brand h1 { font-size: 1rem; }\n\n  /* Show hamburger, hide links by default */\n  .nav-hamburger { display: flex; }\n  .nav-links {\n    display: none;\n    width: 100%;\n    flex-direction: column;\n    gap: 0;\n    order: 10;\n    background: #0f172a;\n    border-top: 1px solid #334155;\n    margin-top: 0.5rem;\n  }\n  .nav-links.nav-open { display: flex; }\n  .nav-links a {\n    padding: 0.6rem 0.75rem;\n    font-size: 0.85rem;\n    border-bottom: 1px solid #1e293b;\n  }\n\n  /* Hide user section on mobile (sign out via settings) */\n  .nav-user { display: none; }\n\n  .container { padding: 0.6rem; }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
